export const getIframeParentUrl = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location !== window.parent.location
    ? document.referrer
    : document.location.href;
};
